
import Popup from 'vux/src/components/popup/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

import {urlConfig} from '@/api/urlConfig';
import {fetch, promptMessage, baseUrl } from '@/api/dataHandling';
import {getken} from '@/api/getToken'
export default {
data(){
return{
haveOrder:false,
ListDetail:[],
ListDetailshow:false,
personshow:false,
value:'',
personoptions:[],
diagItemCode:'',
diagItemName:'',
diagItemPrice:'',
card:'',
name:'',
hospital:'',
cardIcon:true,
submitDisable:false,
birthday:'',
}
},
directives: {
TransferDom
},
components: {
Popup,Confirm, Cell, Checker, CheckerItem, Checklist, Toast, Icon, Grid, GridItem, GroupTitle, Flexbox, FlexboxItem, Datetime, XTextarea, XInput, XHeader, Radio, XButton, Group, PopupRadio
},
methods:{
personchange(value, label){
for(let i=0;i<this.personoptions.length;i++){
if(value ==this.personoptions[i].personInfoId){
this.name = this.personoptions[i].patientName;
this.birthday = this.personoptions[i].birthday;
this.personInfoId = this.personoptions[i].personInfoId;
this.getprojectMsg();
this.personshow = false;

}

}
},
cardBlur(){

if(this.card){
this.submitDisable = false;
this.card = this.card.trim();
this.getpersonMsg(this.card);
this.cardIcon = false;
}else{
this.cardIcon = true;
}

},
IconClick(text){
this.$vux.toast.show({
type: 'text',
text:text
})
},
sureClick(){

if(this.personInfoId && this.hosCode){
for(let i =0;i<this.ListDetail.length;i++){
if(this.diagItemPrice != 0 && this.ListDetail[i].diagItemCode == this.diagItemCode && this.ListDetail[i].sjfztDm == '10'){  //不是免费项目并且有未计费订单
this.haveOrder = true;
}
}

this.timestamp = Date.parse(new Date());
this.submitDisable = true;
let _this = this;
if(this.$route.query.hosCode=='510100000008'){
this.location="sgtszzx";
}else{
this.location="scvif";
}
if(this.haveOrder){  //已存在未交费订单
promptMessage('提示','已存在未缴费订单，前去缴费',function(){

window.location.href = "http://app.cdxt.com.cn/"+_this.location+"/pages/payMain.html?t="+_this.timestamp;

});
}else{
fetch('post',urlConfig.nucleicAcidSave,{personInfoId:this.personInfoId,hosCode:this.hosCode}).then(response => {   //获取院区
console.log(response,8);
this.submitDisable = false;
promptMessage('提示','提交成功，点击确认去缴费',function(){
if(_this.diagItemPrice != 0){

window.location.href = "http://app.cdxt.com.cn/"+_this.location+"/pages/payMain.html?t="+_this.timestamp;
}else{
_this.$router.push({path:'/nucleicAcidDetail?applicationNo='+ response});
}


});

}).catch(error => {
this.submitDisable = false;
});
}

}else if(!this.personInfoId){
promptMessage('提示','请输入患者就诊卡号/身份证号/手机号码');
this.submitDisable = false;
}

},
getprojectMsg(){
fetch('post',urlConfig.getnucleicAcidproject,{personInfoId:this.personInfoId,hosCode:this.hosCode}).then(response => {   //获取院区
console.log(response,4);
this.diagItemCode = response.diagItemCode;
this.diagItemName = response.diagItemName;
this.diagItemPrice = response.diagItemPrice;
this.hospital = response.hosAreaName;
this.$store.commit('updateLoadingStatus', {isLoading: false})
}).catch(error => {

});
},
getpersonMsg(id,blooen){
this.personoptions = [];
fetch('get',urlConfig.getpatientMsg+'?card='+id).then(response => {   //获取院区
if(response.length == 1){
console.log(response,7)
this.name = response[0].patientName;
this.birthday = response[0].birthday;
this.personInfoId = response[0].personInfoId;
if(blooen){
this.card = response[0].idCard;
this.cardIcon = false;
}
this.getprojectMsg();
}else if(response.length>1){
this.personoptions = response;
for(let i=0;i<response.length;i++){
this.personoptions[i]['key'] = response[i].personInfoId;
this.personoptions[i]['value'] = response[i].patientName +'   ' +response[i].identityNo;

}
this.personshow = true;
}

}).catch(error => {
this.IconClick(error);
this.cardIcon = true
});
},
getUserId(){
fetch('get',urlConfig.GetSfzh + '?openid='+this.$route.query.openid).then(response => {
console.log(response.sfzh,23)
this.getpersonMsg(response.sfzh,true);
this.getpersoninfoId(response.sfzh);
}).catch(error => {

})
},
getpersoninfoId(sfz){
fetch('post',urlConfig.GetPersonInfoId +'?sfzh='+sfz).then(response => {
this.dangqianpersonInfoId = response.personInfoId;   
console.log(this.dangqianpersonInfoId,'当前')
this.getmsgList();
}).catch(error => {
})
},
getmsgList(){
fetch('post',urlConfig.nucleicAcid + '?personInfoId='+this.dangqianpersonInfoId).then(response => {
console.log(response,789)
this.ListDetail = response;

}).catch(error => {

})
},
look(id){
this.$router.push({path:'/nucleicAcidDetail?applicationNo='+ id+ '&personInfoId='+this.dangqianpersonInfoId});
}
},
mounted() {
this.$store.commit('updateLoadingStatus', {isLoading: true})
this.hosCode = this.$route.query.hosCode;
getken(this.getUserId);
this.$nextTick(function(){
$('.inputClick').on('click',function(){
$(this).find('input').focus();
})
})
}
}



// WEBPACK FOOTER //
// ./src/project/selfHelpFilingProject/nucleicAcid.vue